<template>
  <b-row
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
    ref="bread_crumb_ref"
    class="content-header"
  >
    <!-- Content Left -->
    <b-col
      class="content-header-left"
      cols="12"
      md="9"
    >
      <b-row class="breadcrumbs-top">
        <b-col cols="12">
          <h2 class="content-header-title float-left pr-1 mb-0">
            {{ $route.meta.pageTitle }}
          </h2>
          <div class="breadcrumb-wrapper">
            <b-breadcrumb>
              <b-breadcrumb-item to="/">
                <feather-icon
                  icon="HomeIcon"
                  size="16"
                  class="align-text-top"
                />
              </b-breadcrumb-item>
              <b-breadcrumb-item
                v-for="item in getLocaleBreadCrumb"
                :key="item.text"
                :active="item.active"
                :to="item.to"
              >
                {{ $t(item.i18n) || item.text }}
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
      </b-row>
    </b-col>

   </b-row>
</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem, BRow, BCol,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapGetters } from 'vuex'

export default {
  directives: {
    Ripple,
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
  },
  computed: {
    ...mapGetters('breadcrumb', ['GET_BREADCRUMB']),
    getLocaleBreadCrumb() {
      if (this.$route.meta.is_dynamic_route) return this.GET_BREADCRUMB
      return this.$route.meta.breadcrumb
    },
  },
}
</script>
